<template>
  <div class="hello">
    <div class="">
      <div class="row">
        <div class="col-lg-2">
          <!-- Logo ou autre si besoin -->
        </div>
        <div class="col-lg-8">
          <div class="search container-fluid">
            <input @input="debouncedSearch" v-model="searchTerm" type="text" placeholder="Rechercher un article...">
            <select @change="searchArticles(currentPage)" v-model="selectedMag">
              <option value="">Tous les magasins</option>
              <option v-for="magasin in magasins" :key="magasin.id" :value="magasin.id_magasins">{{ magasin.nom_magasins }}</option>
            </select>
            <select @change="searchArticles(currentPage)" v-model="selectedFourn">
              <option value="">Tous les fournisseurs</option>
              <option v-for="fournisseur in fournisseurs" :key="fournisseur.id" :value="fournisseur.cofou">{{ fournisseur.nom }}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2">
          <!-- Espace vide pour alignement -->
        </div>
      </div>
    </div>

    <div class="tabC">
      <div class="top-bar container-fluid mb-3">
        <div class="sort-bar">
          <span class="">Trier par :</span>
          <button type="button" class="sort-btn" @click="handleColumnSort('coarti')">
            Code article
            <span v-if="sortColumn === 'coarti'">
              <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
              <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
            </span>
          </button>
          <button type="button" class="sort-btn" @click="handleColumnSort('qte')">
            Quantité
            <span v-if="sortColumn === 'qte'">
              <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
              <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
            </span>
          </button>
          <button type="button" class="sort-btn" @click="handleColumnSort('fourn')">
            Fournisseur
            <span v-if="sortColumn === 'fourn'">
              <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
              <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
            </span>
          </button>
          <button type="button" class="sort-btn" @click="handleColumnSort('nom_magasins')">
            Magasin
            <span v-if="sortColumn === 'nom_magasins'">
              <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
              <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
            </span>
          </button>
          <button type="button" class="sort-btn" @click="handleColumnSort('date_inventaire')">
            Date inventaire
            <span v-if="sortColumn === 'date_inventaire'">
              <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 2 L8 7 H2 Z" fill="#2b358d"/></svg>
              <svg v-else width="10" height="10" viewBox="0 0 10 10" style="margin-left:2px;"><path d="M5 8 L2 3 H8 Z" fill="#2b358d"/></svg>
            </span>
          </button>
        </div>
        <div class="actionsAdmin">
          <div class="pagination-pages">
            <span>Page:</span>
            <select @change="searchArticles(parseInt($event.target.value))">
              <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
            </select>
            <span>sur {{ nb_pages }}</span>
          </div>
          <a class="download ms-3" @click="downloadDatas"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="0 0 16 16">
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"/>
          </svg>Exporter vers CSV</a>
        </div>
      </div>
      <div class="row">
        <template v-if="articles.length === 0">
          <div class="no-articles col-12">Pas de produits disponibles.</div>
        </template>
        <template v-else>
          <RouterLink v-for="article in articles" :key="article.id" :to="getArticleLink(article)" class="col-xl-3 col-lg-4 col-md-6 col-12 article-card-link" style="display: flex;">
            <div v-if="article.coarti.trim() !== ''" class="article-card" style="width: 100%;">
              <div class="card-header">
                <div class="code-article">
                  <div class="top">
                    <strong>Code article : </strong>{{ article.coarti }}
                  </div>
                  <div class="bottom">
                    <span>{{ article.nom_magasins }}</span>
                  </div>
                </div>
                <span class="card-actions">
                  <a href="#" @click.prevent.stop="openPopup(article)" class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-quote-fill" viewBox="0 0 16 16"><path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/></svg>
                  </a>
                </span>
              </div>
              <div class="card-body">
                <div class="content">
                  <div class="card-title">
                    <div class="desa1">{{ article.desa1 }}</div>
                    <div class="desa2">{{ article.desa2 }}</div>
                    <div class="desa3">{{ article.desa3 }}</div>
                  </div>
                  <div class="card-infos">
                    <span class="info-chip">Fournisseur : <strong>{{ article.fourn }}</strong></span>
                    <span class="info-chip">Quantité : <strong :class="{ 'danger': article.qte <= 0, 'success': article.qte > 0 }">{{ article.qte }}</strong></span>
                    <span class="info-chip">Magasin : <strong>{{ article.nom_magasins }}</strong></span>
                    <span class="info-chip">Inventaire : <strong>{{ formatDate(article.date_inventaire) }}</strong></span>
                    <span class="info-chip">Besoin : <strong>{{ article.besoin }}</strong></span>
                  </div>
                </div>
                <span class="besoin-couvert">
                  <span v-if="article.besoin_couvert > 0" class="greenBall"></span>
                  <span v-else-if="article.besoin_couvert == 0" class="orangeBall"></span>
                  <span v-else class="redBall"></span>
                </span>
              </div>
            </div>
          </RouterLink>
        </template>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>

    <!-- Popup -->
    <div v-if="popupOpen" class="popup" @click="closePopup">
      <div class="popup-content" @click.stop>
        <div class="popup-header">
          <h2>{{ popupArticle.desa1 }}</h2>
          <a class="close-button" @click="closePopup">&times;</a>
        </div>
        <div class="popup-body">
          <p v-if="this.commentaire!=''">{{ this.commentaire }}</p>
          <p v-else>Pas de commentaire pour le moment pour cet article.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'

export default {
  data() {
    return {
      multisit: [],
      articles: [],
      fournisseurs: [],
      magasins: [],
      besoins: [],
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      selectedMag: '',
      selectedFourn: '',
      isLoading: false,
      popupOpen: false,
      popupArticle: null,
      commentaire: '',
      sortColumn: '',
      sortDirection: 'asc',
      loggedInRole: null,
    }
  },
  mounted() {
    const role = VueCookies.get('role')
    if (role) {""
      this.loggedInRole = role
    }

    

      // Récupération des données de l'API PHP
      this.currentPage = parseInt(this.$route.query.page) || 1;
      this.searchTerm = this.$route.query.searchTerm || '';
      this.selectedMag = this.$route.query.selectedMag || '';
      this.selectedFourn = this.$route.query.selectedFourn || '';
      this.sortColumn = this.$route.query.sortColumn || 'qte';
      this.sortDirection = this.$route.query.sortDirection || 'asc';

      this.searchArticles(this.currentPage);

      axios.get('https://www.simef.fr/espace-client/api/getMagasinsAchats.php')
      .then(response => {
        this.magasins = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });

      axios.get('https://www.simef.fr/espace-client/api/getFournisseursAchats.php')
      .then(response => {
        this.fournisseurs = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });

  }, 
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';
      this.selectedMag = to.query.selectedMag || '';
      this.selectedFourn = to.query.selectedFourn || '';
      this.sortColumn = to.query.sortColumn || 'qte';
      this.sortDirection = to.query.sortDirection || 'asc';

      this.searchArticles(this.currentPage);
    }
  },
  methods: {
    searchArticles(page) {
      this.isLoading = true; // Show loader
      axios.get(`https://www.simef.fr/espace-client/api/getArticlesAchats.php?page=${page}&searchTerm=${this.searchTerm}&selectedMag=${this.selectedMag}&selectedFourn=${this.selectedFourn}&sortColumn=${this.sortColumn}&sortDirection=${this.sortDirection}`)
        .then(response => {
          this.articles = response.data.articles;
          this.nb_pages = response.data.nb_pages;
          this.currentPage = page;
        })
        .catch(error => {
          console.error(error);
          
        })
        .finally(() => {
          this.isLoading = false; // Hide loader
        });

        this.$router.push({
          query: {
            page: page,
            searchTerm: this.searchTerm,
            selectedMag: this.selectedMag,
            selectedFourn: this.selectedFourn,
            sortColumn: this.sortColumn,
            sortDirection: this.sortDirection,
          }
        });
    },
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    getArticleLink(article) {
      // Create the base URL

      var articleName =  article.desa1.replace(/\//g, "%2F").trim();
      var articleName2 =  article.desa2.replace(/\//g, "%2F").trim();
      var articleName3 =  article.desa3.replace(/\//g, "%2F").trim();
      var coarti =  article.coarti.replace(/\//g, "%2F").trim();
      var magasin =  article.nom_magasins.replace(/\//g, "%2F").trim();

      if (articleName === '') {
        articleName = 'empty';
      }
      if (articleName2 === '') {
        articleName2 = 'empty';
      }
      if (articleName3 === '') {
        articleName3 = 'empty';
      }
      if (coarti === '') {
        coarti = 'empty';
      }
      if (magasin === '') {
        magasin = 'empty';
      }

      let url = '/article-achat/' + articleName + '/' + articleName2 + '/' + articleName3 + '/' + coarti + '/' + magasin;

      // Add the optional parameters if they are not empty
      if (this.currentPage) {
        url += '/' + this.currentPage;
      } else {
        url += '/empty';
      }
      if (this.searchTerm) {
        url += '/' + this.searchTerm;
      } else {
        url += '/empty';
      }
      if (this.selectedFourn) {
        url += '/' + this.selectedFourn;
      } else {
        url += '/empty';
      }
      if (this.selectedMag) {
        url += '/' + this.selectedMag;
      } else {
        url += '/empty';
      }
      if (this.sortColumn) {
        url += '/' + this.sortColumn;
      } else {
        url += '/empty';
      }
      if (this.sortDirection) {
        url += '/' + this.sortDirection;
      } else {
        url += '/empty';
      }

     

      // Return the final URL
      return url;
    },
    openPopup(article) {
      axios.post('https://www.simef.fr/espace-client/api/getCommentaire.php', {
        codeArticleCom: article.coarti
      })
      .then(response => {
          this.commentaire = response.data;
      })
      .catch(error => {
          console.log(error);
      });

      this.popupOpen = true;
      this.popupArticle = article;
    },

    closePopup() {
      event.stopPropagation();
      this.popupOpen = false;
      this.popupArticle = null;
    },

    handleColumnSort(column) {
      if (this.sortColumn === column) {
        // Reverse the sorting direction if the same column is clicked again
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Sort the clicked column in ascending order by default
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }

      // Call the searchArticles method with the current page and sorting parameters
      this.searchArticles(this.currentPage);
    },
  
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $primary: #2b358d;
  .actionsAdmin {
    display: flex;
    gap: 15px;
    align-items: center;
    @media screen and (max-width:992px) {
        flex-wrap: wrap;
        justify-content: center;
    }
    a {
      margin: 0px!important;
      background: #2b358d;
      color: #fff !important;
      padding: 10px 20px;
      @media screen and (max-width:992px) {
        margin-right: 0px;
        margin-bottom: 15px;
      }
      svg {
        margin-right: 10px;
      }
    }
  }
  .download {
    cursor: pointer;
  }
  .containerTab {
    max-height: 500px;
    th {
      min-width: 135px;
    }
  }
  .arrowSort {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    height: 100%;
    svg {
      height: 12px;
    }
  }
  th {
    cursor: pointer;
  }
  .bulle {
    background-color: red;
    position: fixed;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
  }
  .com {
    a {
      height: 100%;
      width: 100%;
      display: flex!important;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
        height: 18px;
        widows: 18px;
      }
    }
  }
  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  button {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
  }
  
  .check {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    font-weight: 500;
    color: #2b358d !important;
    input {
      margin-right: 5px;
    }
  }
  .pagination-pages {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
    @media screen and (max-width:992px) {
      width: 100%;
    }
    span {
      cursor: pointer;
      margin: 3px 4px;
      font-size: 0.9rem;
      font-weight: 500;
    }
    .active {
      color: $primary;
      font-weight: 900;
    }
    select {
      color: #333!important;
      border: 0px;
      padding: 12px 15px;
      margin-right: 10px;
    }
  }

  table.articlesListe {
    width: 100%;
    tbody {
      a {
        font-size: 0.9rem;
        color: #2b358d;
        display: contents;
      }
    }
    thead {
      background: #2b358d!important;
      color: #fff!important;
      position: sticky;
      top: 0px;
    }
    th, td {
      padding: 8px;
      font-size: 0.9rem;
      font-weight: 500!important;
      color: #1d1d20;
    }
    th {
      color: #fff!important;
    }
    .ligne-claire {
      background-color: #f7f7f7;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }

  }

  .search {
      @media screen and (max-width:992px) {
        input[type="text"] {
            margin-bottom: 10px;
        }
      }
  }
 

  .danger {
    color: red!important;
  }
  .success {
    color: #00d712!important;
  }
  .warning {
    color: #ffa600!important;
  }

  .bloc-danger {
    color: #fff!important;
    background: red!important;
    padding: 8px 15px;
    border-radius: 50px;
  }
  .bloc-warning {
    color: #fff!important;
    background: #ffa600!important;
    padding: 8px 15px;
    border-radius: 50px;
  }
  .bloc-success {
    color: #fff!important;
    background: #00d712!important;
    padding: 8px 15px;
    border-radius: 50px;
  }

  
  .search {
    
    input[type="text"], select {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        &:focus-visible {
          outline: $primary auto 1px;
          border-color: $primary;
          border-radius: 0px;
        }
    }
    select {
      @media screen and (max-width:992px) {
          margin-bottom: 10px;
        
      }
    }
  }
  .loader {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #0b0b0baa;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
z-index: 99999;
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 998!important;
  }
  
  .popup-content {
    max-width: 850px;
    max-height: 90%;
    background: #f2f2f2 !important;
    padding: 40px 60px;
    color: #1d1d20;
    @media screen and (max-width:992px) {
      max-width: 90%;
      max-height: 90%;
    }
    p {
      color: #1d1d20;
    }
  }
  
  .popup-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    h3 {
      margin: 0px;
    }
  }
  
  .close-button {
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    padding: 3px 7px!important;
    top: 4%;
    font-size: 1.5rem;
    transform: translateX(-100%);
    left: 98%;
    margin: 0px !important;
    color: #2b358d;
    line-height: 1!important;
}
  
  .entete.logoClientearch {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px!important;
    .logoClient {
      margin: 0px;
      margin-right: 20px;
    }
    .search.container-fluid {
      margin-bottom: 0px!important;
    }
  }
  .dispo {
    margin-top: 10px;
    @media screen and (max-width:992px) {
      margin-top: 0px;
    }
  }

  @media screen and (max-width:1070px) {
    .tabC {
      overflow-x: scroll;
    }
    .logos {
      margin-bottom: 30px;
      img {
        width: 50%;
        height: auto;
      }
    }
  }

  .coordonnees {
    margin-top: 20px;
    h2 {
      margin-bottom: 5px!important;
      text-align: center;
      font-size: 1.2rem!important;
    }
    p {
      font-size: 0.9rem;
    }
  }

  .actionsClient {
    display: flex;
    flex-wrap: wrap;
  }
  .indic {
    font-style: italic;
    font-size: 0.9rem;
  }

  .article-card-link {
    text-decoration: none;
    color: inherit;
  }
  .article-card {
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    min-height: 180px;
    position: relative;
    transition: box-shadow 0.2s;
    width: 100%;
    border: 1px solid #cbcbcb;
    border-radius: 0px;
    &:hover {
      box-shadow: 0 4px 16px rgba(43,53,141,0.15);
    }
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px!important;
    background: #2b358d;
    padding: 10px 20px;
    color: #fff;
  }
  .card-body {
    display: flex;
    height: 100%;
    .content {
      width: 92%;
      padding: 15px;
    }
    .besoin-couvert {
      width: 8%;
      margin-left: 0px;
      span {
        height: 100%;
        width: 100% ;
        border-radius: 0px;
        
      }
    }
  }
  .card-title {
    margin-bottom: 10px;
    min-height: 70px;
    .desa1 {
      font-size: 1.1rem;
      font-weight: 700;
      color: #1d1d20;
    }
    .desa2, .desa3 {
      font-size: 0.9rem;
      color: #1d1d20;
      font-weight: 600;
    }
  }
  .card-infos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
    flex-direction: column;
  }
  .info-chip {
    background: #f5f5f5;
    border-radius: 12px;
    padding: 4px 10px;
    font-size: 0.9rem;
    color: #1d1d20;
    display: flex;
    align-items: center;
    font-weight: 600;
    gap: 3px;
  }
 
  .no-articles {
    grid-column: 1/-1;
    text-align: center;
    color: #888;
    font-size: 1.1rem;
    padding: 32px 0;
  }
  .sort-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    span {
      font-weight: 600;
      color: #2b358d;
      font-size: 1rem;
      svg {
        margin-left: 5px!important;
        margin-right: 0!important;
      }
    }
    .sort-btn {
      color: #fff;
      border: none;
      padding: 6px 14px;
      font-weight: 600;
      font-size: 0.98rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 0px!important;
      svg {
        path {
          fill: #fff;
        }
      }
      &:hover, &.active {
        background: #dbe9fa;
      }
      svg {
        margin-left: 2px;
      }
    }
  }
  .code-article {
    font-weight: 700;
    font-size: 1rem;
    text-align: left;
  }
  .com-link {
    background: #fff;
    padding: 5px 10px;
    border-radius: 0px;
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    
    font-weight: 600;
    a {
      gap: 3px;
    }
  }
  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    @media screen and (max-width: 992px) {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  .right-actions {
    display: flex;
    align-items: center;
    gap: 18px;
    
   
  }
</style>
